import { Component, OnInit } from '@angular/core';
import {ActionHistoryService} from './action-history.service';
import {AuthService} from '../../../core/service/auth.service';
import {MessagingService} from '../../../core/service/messaging.service';
import {AlertaService} from '../../services/alerta.service';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ModalService} from 'ngx-dynamic-modal';
import {EditActionHistoryModalComponent} from '../modals/edit-action-history-modal/edit-action-history-modal.component';

@Component({
  selector: 'app-action-history',
  templateUrl: './action-history.component.html',
  styleUrls: ['./action-history.component.scss']
})
export class ActionHistoryComponent implements OnInit {

  enabled=false;
  elements: Array<any>=[];
  portal:any;
  formSearch:FormGroup;

  constructor(private actionHandler:ActionHistoryService,
              private auth:AuthService,
              private messaging:MessagingService,
              private alerta:AlertaService,
              private modal:ModalService) {
      this.formSearch=new FormGroup(
          {
              'service_pk':new FormControl('',Validators.required)
          }
      )

  }

  ngOnInit() {
      this.portal=this.auth.getPkPortal();

      this.messaging.message.subscribe(portal => {
          if(portal.hasOwnProperty('pkPortal') && portal.pkPortal !== this.portal) {
              this.portal = portal.pkPortal;
              this.elements=[];
          }
      });
  }

  getElements(form){
      if(form.valid){
          this.enabled=true;
          this.actionHandler.getList({portal_pk:this.portal,service_pk:this.formSearch.value.service_pk})
              .subscribe(result=>{
                  this.elements=result;
                  this.enabled=false;
              })
      }

  }

  deleteElement(element){
      this.alerta.addAlert('confirm','Do you want to Delete this Element?')
          .then((result)=>{
              if(result.value){
                  this.actionHandler.removeAction(element.pk)
                      .subscribe( result => {
                      }, error => {
                          console.log(error);
                          this.alerta.addAlert('error','Something went wrong!!')
                      }, () => {
                          this.alerta.addAlert('success','Element Deleted Succesfully!!')
                          let indx=this.elements.indexOf(element);
                          this.elements.splice(indx,1);
                      })}
          })
  }

  openModal(element=null){
      let params={portal_pk:this.portal};
      this.modal.addDynamicComponent(EditActionHistoryModalComponent,{params,element},(res)=>{
         this.getElements(this.formSearch)
      })

  }







}



// WEBPACK FOOTER //
// /var/www/backend/src/app/shared/components/action-history/action-history.component.ts